module.exports = __webpack_public_path__ + "static/media/013.76231714.jpg";